import {memo} from 'react';
import dynamic from 'next/dynamic';
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));
import parse from 'html-react-parser';
import Link from 'next/link';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import type {SxProps, Theme} from '@mui/material/styles';
import {colors, fontFamily, fontSize, fontWeight, lineHeightRatio, spacing} from '@/styles/tokens';

const sxNewWallet = {
    textAlign: 'center',
    height: '100%',
    padding: '15px', // no exact spacing-token match
    border: '1px solid #d2d2d2' // no exact token match
};

const sxHeadSubhead = {
    paddingTop: '10px' // no exact spacing-token match
};

// Migrated from globals.scss `.wallet-img`.
const walletImgStyle = {marginTop: spacing[16]} as const;

// Migrated from globals.scss `.crypto_heading` base rule. The `mobileScreen` responsive
// override (font-size: 20px) stays in globals.scss — see the crypto_heading/one-step-content-heading
// comma-split note there.
const sxCryptoHeading = {
    fontFamily: fontFamily.heading,
    fontSize: fontSize[22],
    fontWeight: fontWeight.bold,
    color: colors.text.primary,
    lineHeight: '30px' // no exact lineHeight-token match
};

// Migrated from globals.scss `.crypto_sub_heading` base rule.
const sxCryptoSubHeading = {
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.regular,
    fontSize: fontSize[16],
    color: colors.text.primary,
    marginTop: spacing[8],
    lineHeight: lineHeightRatio.normal,
    a: {
        textDecoration: 'none'
    }
};

// `xSx`/`subheadingSx` are additive sx escape hatches for the card box / subheading Typography,
// alongside the existing `className`/`subheadingClass` string passthroughs. Migrating this
// component's consumers off global CSS is separate, long-tail work (Initiative 6).
const CryptoWallet = (props: any) => {
    const {data, heading, subheading, className, subheadingClass, xSx, subheadingSx} = props;
    return (
        <>
            <Box className="spectrum-header-wrapper solutions">
                <Typography className="spectrum-heading color-black" pt={5}>
                    {heading}
                </Typography>
                <Box className="divder-wrapper">
                    <hr className="divider-line" />
                </Box>
                <Box className="sub-heading-box" pb={3.8}>
                    <Typography className={`${subheadingClass} spectrum-sub-heading color-black spacing data_links `} sx={subheadingSx}>
                        {subheading ? parse(subheading) : ''}
                    </Typography>
                </Box>
            </Box>
            <Grid container spacing={2}>
                {data?.map((subData: any, index: number) => (
                    <Grid item xs={12} sm={6} md={4} lg={4} key={index + 1}>
                        <Box className={className} sx={[sxNewWallet, xSx] as SxProps<Theme>}>
                            <DisplayImage
                                src={subData.img}
                                alt={subData.heading}
                                className={`wallet_img_${index + 1}`}
                                style={walletImgStyle}
                                priority={false}
                            />
                            <Box sx={sxHeadSubhead}>
                                {subData?.redirect ? (
                                    <Link
                                        href={subData?.redirect}
                                        target="_blank"
                                        className="services_link menu-links hover-underline-text"
                                    >
                                        <Typography variant="h6" component="h4" sx={sxCryptoHeading}>
                                            {' '}
                                            {subData.heading}{' '}
                                        </Typography>
                                    </Link>
                                ) : (
                                    <Typography variant="h6" component="h4" sx={sxCryptoHeading}>
                                        {' '}
                                        {subData.heading}{' '}
                                    </Typography>
                                )}

                                <Typography component="p" sx={sxCryptoSubHeading}>
                                    {subData?.subheading ? parse(subData.subheading) : ''}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </>
    );
};
export default memo(CryptoWallet);
